var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "f9ea307hba",
    d: "M14.52.18C6.522.18.037 6.665.037 14.664V49.43c0 8 6.485 14.485 14.485 14.485h34.764c8 0 14.485-6.485 14.485-14.485V14.664c0-8-6.485-14.484-14.485-14.484H14.521z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lpxygyspuc",
    d: "M.212 4.15c2.154.165 3.393 1.269 3.932 5.464L6.298 24.96c.27 2.153 2.209 2.87 4.202 2.87 1.454 0 3.297-.383 4.74-2.263L26.334 8.013c1.185-1.821 1.616-2.76 1.616-3.974 0-3.643-5.17-3.919-5.225-3.809L12.062 19.33l-.97-10.046c-.27-3.698-.916-6.127-2.37-7.617C7.7.616 6.514.175 4.952.175.588.175.104 4.149.212 4.149z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H80V80H0z",
    transform: "translate(-520 -184) translate(520 184)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-520 -184) translate(520 184) translate(8 8)",
    id: "logo-svg-wrapper-id"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mdx43k30zb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f9ea307hba"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6173FE",
    d: "M-6.603 70.553L70.41 70.553 70.41 -6.46 -6.603 -6.46z",
    mask: "url(#mdx43k30zb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-520 -184) translate(520 184) translate(8 8) translate(18 18)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0v8j9gm0id",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lpxygyspuc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M-5.996 34.311L34.146 34.311 34.146 -6.306 -5.996 -6.306z",
    mask: "url(#0v8j9gm0id)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ab26476e.svg";
export { ForwardRef as ReactComponent };